export const toggleBodyClass = {
    methods: {
        toggleBodyClass(className) {
            document.body.classList.toggle(className)
        }
    }
}
